import { useEffect } from 'react';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import HTMLWrapper from '@comp/Question/HTMLWrapper';
import useQuestion from '@cont/Quiz/Taking/Objective/Question/useQuestion';
import { sendViewedQuestion } from '@actions/quizTaking';
import {
  getCurrentQuestionInfo,
  getCurrentSessionUID
} from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import Dangerous from '@educator/Container/AutoDPP/DangerousContent';
import { NTA_COLORS } from '../constants';
import { ntaPageCss, ntaQuestionContentCss } from '../typography';
import NtaOptions from './NtaOptions';

const Wrapper = styled.div`
  user-select: none;
  ${ntaPageCss}
`;

const QuestionContent = styled.div`
  ${ntaQuestionContentCss}

  table {
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid ${NTA_COLORS.questionBorder};
    padding: 4px 8px;
  }
`;

const NtaObjectiveQuestion = () => {
  const dispatch = useDispatch();
  const { query } = useRouter();
  const { quizUID } = query;
  const currentSessionUID = useSelectorWithShallowEqual(getCurrentSessionUID);
  const { sectionUID, questionUID } = useSelectorWithShallowEqual(
    getCurrentQuestionInfo
  );
  const { currentQuestion, currentLanguage } = useQuestion();

  useEffect(() => {
    dispatch(
      sendViewedQuestion({
        quizUID,
        sessionUID: currentSessionUID,
        questionUID,
        sectionUID,
        isRevampedTestVersion2: true
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionUID]);

  return (
    <Wrapper data-testid="objective-question-wrapper">
      <QuestionContent>
        <Dangerous
          as={HTMLWrapper}
          data-image-preview
          $isImageClickable={false}
          html={currentQuestion?.content?.[currentLanguage?.code]}
        />
      </QuestionContent>
      <NtaOptions code={currentLanguage.code} />
    </Wrapper>
  );
};

export default NtaObjectiveQuestion;
